<template>
  <div>
    <b-tooltip
      target="warningSistemaIndisponivel"
      placement="bottom"
    >
      Novas funcionalidades disponíveis! Clique para saber mais.
    </b-tooltip>
    <font-awesome-icon
      id="warningSistemaIndisponivel"
      class="warning-indisponivel"
      icon="fa-solid fa-tower-broadcast"
      size="lg"
      fade
      @click="abrirModal"
    />
  </div>
</template>

<style lang="scss">

.warning-indisponivel {
  background-color: #fc50001c;
  color: #f3851f;
  margin: .5rem;
  padding: 8px;
  border-radius: 50%;
}

</style>

<script>

/* eslint-disable no-param-reassign */
import Ripple from 'vue-ripple-directive'
import useModalSistemaIndisponivel from './shared/components/useModalSistemaIndisponivel'

export default {
  directives: {
    Ripple,
  },
  methods: {
    abrirModal() {
      useModalSistemaIndisponivel(this.$router)
    },
  },
}
</script>
